const AiLlmRoutes = [
    {
        path: '',
        redirect: {name: 'list-ai-llm'},
    },
    {
        path: 'groups',
        name: 'list-ai-llm',
        component: () => import("@/components/admin/ai-llm/list.vue"),
    },
    {
        path: 'list',
        redirect: {name: 'list-ai-llm'},
    },
    {
        path: 'deployments',
        name: 'list-ai-llm-deployment',
        component: () => import("@/components/admin/ai-llm/deployment-list.vue"),
    },
    {
        path: 'task-routing',
        name: 'ai-llm-task-routing',
        component: () => import("@/components/admin/ai-llm/task-routing.vue"),
    },
    {
        path: 'consumption',
        name: 'ai-llm-consumption',
        component: () => import("@/components/admin/ai-llm/consumption.vue"),
    },
    {
        path: 'form',
        name: 'form-ai-llm',
        component: () => import("@/components/admin/ai-llm/form.vue"),
    },
    {
        path: 'deployment-form',
        name: 'form-ai-llm-deployment',
        component: () => import("@/components/admin/ai-llm/deployment-form.vue"),
    }
];
export default AiLlmRoutes
